import {
  getCookies,
  setCookies,
} from "@/utils/common/cookiesHelper/CookiesUtills";
import dayjs from "@/utils/dayjs";
import { CookiesItemEnum } from "@/utils/enums/CookiesItemEnum";
import { UtmChanelEnum } from "@/utils/enums/UtmChanelEnum";

import { getAffiliateWindow } from "./AffiliateWindow";

export interface CartItems {
  name: string;
  quantity: number;
  sku: string | undefined;
  price: number;
}
export interface HoneycombAffiliateWindow {
  pageView: () => Promise<void>;
  getTracking: () => void;
  addToCart: (items: CartItems[]) => Promise<void>;
}

export const honeycombPageViewHandler = async () => {
  const cw = getAffiliateWindow();
  const isHoneycombAffiliate = !!cw?.honeycombAffiliate;

  if (isHoneycombAffiliate) {
    await cw?.honeycombAffiliate?.pageView();
  } else return false;

  return true;
};

export const honeycombHandler = (payload: CartItems[]) => {
  const utmID = getCookies(CookiesItemEnum.COOKIE_UTM_ID);
  if (utmID !== UtmChanelEnum.HONEY_COMB) {
    return;
  }
  const affId = getCookies(CookiesItemEnum.COOKIE_PARTNER_TOKEN_ID);
  setCookies(
    CookiesItemEnum.COOKIE_PARTNER_TOKEN_ID,
    affId,
    true,
    dayjs().add(1, "day"),
  );

  setCookies(
    CookiesItemEnum.COOKIE_UTM_ID,
    UtmChanelEnum.HONEY_COMB,
    true,
    dayjs().add(1, "day"),
  );

  const cw = getAffiliateWindow();
  const isHoneycombAffiliate = !!cw?.honeycombAffiliate;
  if (isHoneycombAffiliate) {
    cw?.honeycombAffiliate?.addToCart(payload);
  }
};
